import { render, staticRenderFns } from "./stockOperateCollect.vue?vue&type=template&id=69c2bf74"
import script from "./stockOperateCollect.vue?vue&type=script&lang=js"
export * from "./stockOperateCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports